export function convertMonthAndNum(input) {
	let val = null;
	const monthMapping = {
		1: "early-january",
		2: "late-january",
		3: "early-february",
		4: "late-february",
		5: "early-march",
		6: "late-march",
		7: "early-april",
		8: "late-april",
		9: "early-may",
		10: "late-may",
		11: "early-june",
		12: "late-june",
		13: "early-july",
		14: "late-july",
		15: "early-august",
		16: "late-august",
		17: "early-september",
		18: "late-september",
		19: "early-october",
		20: "late-october",
		21: "early-november",
		22: "late-november",
		23: "early-december",
		24: "late-december",
		"early-january": 1,
		"late-january": 2,
		"early-february": 3,
		"late-february": 4,
		"early-march": 5,
		"late-march": 6,
		"early-april": 7,
		"late-april": 8,
		"early-may": 9,
		"late-may": 10,
		"early-june": 11,
		"late-june": 12,
		"early-july": 13,
		"late-july": 14,
		"early-august": 15,
		"late-august": 16,
		"early-september": 17,
		"late-september": 18,
		"early-october": 19,
		"late-october": 20,
		"early-november": 21,
		"late-november": 22,
		"early-december": 23,
		"late-december": 24,
		blank: "Different Months of the Year",
	};

	if (input) {
		val = monthMapping[input];
	}
	return val;
}

// Generate a list of all 24 half-months
export function listAllHalfMonths() {
	return [
		{ value: 1, desc: "Early January" },
		{ value: 2, desc: "Late January" },
		{ value: 3, desc: "Early February" },
		{ value: 4, desc: "Late February" },
		{ value: 5, desc: "Early March" },
		{ value: 6, desc: "Late March" },
		{ value: 7, desc: "Early April" },
		{ value: 8, desc: "Late April" },
		{ value: 9, desc: "Early May" },
		{ value: 10, desc: "Late May" },
		{ value: 11, desc: "Early June" },
		{ value: 12, desc: "Late June" },
		{ value: 13, desc: "Early July" },
		{ value: 14, desc: "Late July" },
		{ value: 15, desc: "Early August" },
		{ value: 16, desc: "Late August" },
		{ value: 17, desc: "Early September" },
		{ value: 18, desc: "Late September" },
		{ value: 19, desc: "Early October" },
		{ value: 20, desc: "Late October" },
		{ value: 21, desc: "Early November" },
		{ value: 22, desc: "Late November" },
		{ value: 23, desc: "Early December" },
		{ value: 24, desc: "Late December" },
		{ value: "blank", desc: "Any Month" },
	];
}

export const listmonths = [
		{ value: 1, desc: "Early January" },
		{ value: 2, desc: "Late January" },
		{ value: 3, desc: "Early February" },
		{ value: 4, desc: "Late February" },
		{ value: 5, desc: "Early March" },
		{ value: 6, desc: "Late March" },
		{ value: 7, desc: "Early April" },
		{ value: 8, desc: "Late April" },
		{ value: 9, desc: "Early May" },
		{ value: 10, desc: "Late May" },
		{ value: 11, desc: "Early June" },
		{ value: 12, desc: "Late June" },
		{ value: 13, desc: "Early July" },
		{ value: 14, desc: "Late July" },
		{ value: 15, desc: "Early August" },
		{ value: 16, desc: "Late August" },
		{ value: 17, desc: "Early September" },
		{ value: 18, desc: "Late September" },
		{ value: 19, desc: "Early October" },
		{ value: 20, desc: "Late October" },
		{ value: 21, desc: "Early November" },
		{ value: 22, desc: "Late November" },
		{ value: 23, desc: "Early December" },
		{ value: 24, desc: "Late December" }
	]